export const BASE_FONT_SIZE = 16;
export const rem = (pixels) => `${pixels / BASE_FONT_SIZE}rem`;
export default rem;
//# sourceMappingURL=rem.js.map